export enum ChargeAmountPaymentMethod {
  ONLINE_PAYMENT_CARD = 'ONLINE_PAYMENT_CARD',
  DEPOSIT_CARD = 'DEPOSIT_CARD',
  PAYMENT_LINK = 'PAYMENT_LINK',
  DEPOSIT = 'DEPOSIT',
}
